import React, { Fragment, useMemo } from "react";
import DataGrid, { Button, Column, Export, FilterRow, HeaderFilter, Paging, Scrolling, SearchPanel, Selection, Sorting, Summary, TotalItem } from "devextreme-react/data-grid";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import utils, { getDayjsFormatWithTranslate } from "../../../../../utils";
import { getName } from "../../../../../utils/userData";
import loading from "../../../assets/social-media.gif";

const TableIndividual = (props) => {

  const { t, i18n } = useTranslation();
  const { ReportSummaryOvertimeShiftIndividual, isFetching, start, end, searchedFilter } = props;

  function normalizeYMD(d) {
    return dayjs(dayjs(d).format("YYYY-MM-DD"), "YYYY-MM-DD");
  }

  function isWithinInclusive(itemDateStr, startStr, endStr) {
    if (!itemDateStr || !startStr || !endStr) return false;
    var d = normalizeYMD(itemDateStr);
    var s = normalizeYMD(startStr);
    var e = normalizeYMD(endStr);
    return (d.isAfter(s) || d.isSame(s)) && (d.isBefore(e) || d.isSame(e));
  }

  const boundedSchedule = useMemo(function () {
  if (!ReportSummaryOvertimeShiftIndividual) return [];
  var sched = ReportSummaryOvertimeShiftIndividual.schedule;
  if (!sched || !Array.isArray(sched)) return [];

  if (!start || !end) return sched;

  return sched.filter(function (row) {
    if (!row || !row.date) return false;
    return isWithinInclusive(row.date, start, end);
  });
}, [ReportSummaryOvertimeShiftIndividual, start, end]);

  let gridColumnsOverTime = [
    {
      dataField: "otOneHours",
      caption: `OT 1 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otOneAmount",
      caption: `OT 1 (${t("Baht")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otOneFiveHours",
      caption: `OT 1.5 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otOneFiveAmount",
      caption: `OT 1.5 (${t("Baht")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otTwoHours",
      caption: `OT 2 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otTwoAmount",
      caption: `OT 2 (${t("Baht")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otThreeHours",
      caption: `OT 3 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otThreeAmount",
      caption: `OT 3 (${t("Baht")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otHoursTotal",
      caption: `OT ${t("Total")} (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "percentOT",
      caption: `${t("OTPercent")}`,
      format: "0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otAmountTotal",
      caption: `OT ${t("Total")} (${t("Baht")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
  ];

  let gridColumnsOverTimeNotAccess = [
    {
      dataField: "otOneHours",
      caption: `OT 1 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otOneFiveHours",
      caption: `OT 1.5 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otTwoHours",
      caption: `OT 2 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otThreeHours",
      caption: `OT 3 (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "otHoursTotal",
      caption: `OT ${t("Total")} (${t("Hours")})`,
      format: "###,###,##0.00",
      cssClass: "column-ot",
      width: 120,
    },
    {
      dataField: "percentOT",
      caption: `${t("OTPercent")}`,
      format: "0.00",
      cssClass: "column-ot",
      width: 120,
    },
  ];

  let gridColumnsShift = [
    {
      dataField: "morningShiftFee",
      caption: `${t("ShiftPayMorning")}`,
      format: "###,###,##0.00",
      cssClass: "column-shift",
    },
    {
      dataField: "afternoonShiftFee",
      caption: `${t("ShiftPayAfternoon")}`,
      format: "###,###,##0.00",
      cssClass: "column-shift",
    },
    {
      dataField: "nightShiftFee",
      caption: `${t("ShiftPayNight")}`,
      format: "###,###,##0.00",
      cssClass: "column-shift",
    },
    {
      dataField: "shiftFeeTotal",
      caption: `${t("ShiftPayTotal")}`,
      format: "###,###,##0.00",
      cssClass: "column-shift",
    },
  ];

  const displayDate = (info) => {
    return dayjs(info.value).format(
      i18n.language === "th" ? "DD MMM BBBB (ddd)" : "DD MMM YYYY (ddd)"
    );
  };

  const getShiftTypeText = (rowData) => {
    const pattern = rowData.pattern;
    const holiday = rowData.holiday;

    if (!pattern) return t("TimeNotFound");

    const timeRange = pattern.timeIn && pattern.timeOut
      ? `${dayjs(pattern.timeIn, "HH:mm:ss").format("HH:mm")} - ${dayjs(pattern.timeOut, "HH:mm:ss").format("HH:mm")}`
      : "";

    if (holiday) {
      const holidayName = i18n.language === "th"
        ? (holiday.name || "")
        : (holiday.name_EN || holiday.name || "");
      return timeRange ? `${holidayName} (${timeRange})` : holidayName;
    }

    if (pattern.isWorkingDay === 0) {
      const name = pattern.nameShiftType || "";
      return timeRange ? `${name} (${timeRange})` : name;
    }

    return timeRange || t("TimeNotFound");
  };

  const customizeOTHour = (data) => {
    return data.value
      ? `${utils.roundToTwo(data.value)} ${t("ShortHours")}`
      : "";
  };

  const customizeOTAmount = (data) => {
    return data.value ? `${utils.roundToTwo(data.value)} บาท` : "";
  };

  return (
    <Fragment>
      {searchedFilter && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "24px",
            marginBottom: "16px",
            padding: "12px 16px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          {searchedFilter.company && (
            <Box>
              <Typography fontSize="12px" color="text.secondary">{t("Vendor")}</Typography>
              <Typography fontSize="14px" fontWeight="600">
                {searchedFilter.company.vendorName}
              </Typography>
            </Box>
          )}
          {searchedFilter.employee && (
            <Box>
              <Typography fontSize="12px" color="text.secondary">{t("FullName")}</Typography>
              <Typography fontSize="14px" fontWeight="600">
                {getName({ name: searchedFilter.employee.fullname, name_EN: searchedFilter.employee.fullname_en })}
              </Typography>
            </Box>
          )}
          <Box>
            <Typography fontSize="12px" color="text.secondary">{t("StartDate")}</Typography>
            <Typography fontSize="14px" fontWeight="600">
              {searchedFilter.start && getDayjsFormatWithTranslate(searchedFilter.start, "D MMM YYYY", i18n.language)}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize="12px" color="text.secondary">{t("EndDate")}</Typography>
            <Typography fontSize="14px" fontWeight="600">
              {searchedFilter.end && getDayjsFormatWithTranslate(searchedFilter.end, "D MMM YYYY", i18n.language)}
            </Typography>
          </Box>
        </Box>
      )}
      {!isFetching ? (
        <DataGrid
          key={i18n.language}
          dataSource={
            boundedSchedule ? boundedSchedule : []
          }
          showBorders={true}
          showColumnLines={true}
          rowAlternationEnabled={true}
          columnAutoWidth={true}
          allowColumnResizing={true}
          columnResizingMode="widget"
        >
          {/* <Column
            caption={`${t("EmployeeID")}`}
            dataField="employeeID"
            dataType="string"
            width={150}
            cssClass="column-info"
          />

          <Column
            caption={`${t("FullName")}`}
            dataType="string"
            cssClass="column-info"
            dataField={i18n.language === "en" ? "fullname_EN" : "fullname_TH"}
          >
            <HeaderFilter allowSearch={true} />
          </Column>

          <Column
            dataField="sectionName"
            caption={`${t("Section")}`}
            dataType="string"
            cssClass="column-info"
          />

          <Column
            dataField={i18n.language === "en" ? "positionName_EN" : "positionName"}
            caption={`${t("Position")}`}
            dataType="string"
            cssClass="column-info"
          />

          <Column
            dataField="workingType"
            caption={`${t("WorkingType")}`}
            dataType="string"
            width={150}
            cssClass="column-info"
          />

          <Column
            dataField="paymentTypeName"
            caption={`${t("PaymentTypeName")}`}
            dataType="string"
            width={150}
            cssClass="column-info"
          />

          <Column
            dataField="paymentRoundName"
            caption={`${t("PaymentRound")}`}
            dataType="string"
            width={150}
            cssClass="column-info"
          /> */}

          <Column
            dataField="date"
            caption={`${t("Date")}`}
            customizeText={displayDate}
            dataType="string"
            width={150}
            cssClass="column-info"
          />

          <Column
            name="shiftType"
            caption={`${t("TimeAttendance")}`}
            calculateCellValue={getShiftTypeText}
            dataType="string"
            allowFiltering={true}
            allowHeaderFiltering={true}
            width={150}
            cssClass="column-info"
          />

          {ReportSummaryOvertimeShiftIndividual
            //  && ReportSummaryOvertimeShiftIndividual.checkedAccessPayroll
            ? gridColumnsOverTime.map((item, index) => (
              <Column
                key={`overtime_${index}`}
                dataField={item.dataField}
                caption={item.caption}
                format={item.format}
                cssClass="column-total-addition"
              />
            ))
            : gridColumnsOverTimeNotAccess.map((item, index) => (
              <Column
                key={`overtime_${index}`}
                dataField={item.dataField}
                caption={item.caption}
                format={item.format}
                cssClass="column-total-addition"
              />
            ))}

          {ReportSummaryOvertimeShiftIndividual &&
            // ReportSummaryOvertimeShiftIndividual.checkedAccessPayroll &&
            gridColumnsShift.map((item, key) => (
              <Column
                key={`shift_${key}`}
                dataField={item.dataField}
                caption={item.caption}
                format={item.format}
                cssClass={item.cssClass}
              />
            ))}

          <Export enabled={true} allowExportSelectedData={true} />
          <Selection mode="single" />
          <Sorting mode="multiple" />
          <Scrolling columnRenderingMode="virtual" />
          <Paging enabled={false} defaultPageSize={20} />
          <FilterRow visible={false} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            width={240}
            placeholder={`${t("Search")}`}
          />
          <Summary>
            <TotalItem column="date" displayFormat={t("Total")} />
            <TotalItem
              column="otOneHours"
              summaryType="sum"
              customizeText={customizeOTHour}
            />
            <TotalItem
              column="otOneAmount"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
            <TotalItem
              column="otOneFiveHours"
              summaryType="sum"
              customizeText={customizeOTHour}
            />
            <TotalItem
              column="otOneFiveAmount"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
            <TotalItem
              column="otTwoHours"
              summaryType="sum"
              customizeText={customizeOTHour}
            />
            <TotalItem
              column="otTwoAmount"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
            <TotalItem
              column="otThreeHours"
              summaryType="sum"
              customizeText={customizeOTHour}
            />
            <TotalItem
              column="otThreeAmount"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
            <TotalItem
              column="otAmountTotal"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
            <TotalItem
              column="morningShiftFee"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
            <TotalItem
              column="afternoonShiftFee"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
            <TotalItem
              column="nightShiftFee"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />

            <TotalItem
              column="shiftFeeTotal"
              summaryType="sum"
              customizeText={customizeOTAmount}
            />
          </Summary>
        </DataGrid>
      ) : (
        // <Typography textAlign="center" color="text.secondary" fontSize="24px">
        //   {t(`LoadingData`)}...
        // </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            alt="loading"
            src={loading}
            style={{ width: 100, height: 100 }}
          />
        </Box>
      )}
    </Fragment>
  );
};

export default TableIndividual;
